import apiRequest from "./apiClient";

export async function fetchRegions() {
  const body = await apiRequest("/api/v1/admin/regions");
  return body.data;
}

export async function fetchRegion(regionId) {
  const body = await apiRequest(`/api/v1/admin/regions/${regionId}`);
  return body.data;
}

export async function createRegion(payload) {
  const body = await apiRequest("/api/v1/admin/regions", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateRegion(regionId, payload) {
  const body = await apiRequest(`/api/v1/admin/regions/${regionId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function addPincode(regionId, payload) {
  const body = await apiRequest(`/api/v1/admin/regions/${regionId}/pincodes`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function removePincode(pincodeId) {
  await apiRequest(`/api/v1/admin/regions/pincodes/${pincodeId}`, {
    method: "DELETE",
  });
}

export async function updatePincode(pincodeId, payload) {
  const body = await apiRequest(`/api/v1/admin/regions/pincodes/${pincodeId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

/** Public nested regions → [{ pincode, areaName }] for reference / debugging */
export async function fetchPublicServiceRegions() {
  const body = await apiRequest("/api/v1/regions");
  return body.data;
}
